import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { company } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    tone?: 'dark' | 'light'
    className?: string
}

/** Hard hat badge used until the company logo file is added. */
export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 40 40' className={className} aria-hidden='true' focusable='false'>
            <rect width='40' height='40' rx='8' className='fill-ink' />
            <path d='M10 25a10 10 0 0 1 20 0z' className='fill-highlight' />
            <rect x='18.5' y='15' width='3' height='10' className='fill-ink' />
            <rect x='7.5' y='25' width='25' height='3.5' rx='1.75' className='fill-highlight' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ tone = 'dark', className }): ReactNode => {
    const light = tone === 'light'

    return (
        <span className={cn('flex items-center gap-2.5', className)}>
            <LogoMark className='size-10 shrink-0' />

            <span className='flex flex-col'>
                <span className={cn('font-heading text-[1.4rem] leading-none font-extrabold tracking-tight', light ? 'text-white' : 'text-primary')}>
                    {company.shortName}
                </span>

                <span className={cn('mt-1 text-[0.58rem] leading-none font-bold tracking-[0.18em] uppercase', light ? 'text-white/70' : 'text-foreground')}>
                    {company.descriptor}
                </span>
            </span>
        </span>
    )
}
